import { type ComponentProps, useMemo } from 'react';

import { Box } from '@betterment/samba-react';
import { XYChart as VisxXYChart } from '@visx/xychart';

import { type ThemeConfig, createSambaChartTheme } from './theme';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

export type XYChartProps = Omit<ComponentProps<typeof VisxXYChart>, 'aria-label' | 'aria-describedby' | 'theme'> & {
  'aria-label': string;
  css?: SystemStyleObject;
  theme?: Partial<ThemeConfig>;
  'aria-describedby': string;
};

export const XYChart = ({
  children,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedby,
  css: cssProp,
  theme,
  ...otherProps
}: XYChartProps) => {
  const chartTheme = useMemo(() => createSambaChartTheme(theme), [theme]);

  return (
    <Box
      tabIndex={0}
      aria-label={ariaLabel}
      css={{ display: 'inline-block', ...cssProp }}
      aria-describedby={ariaDescribedby}
      role="img"
    >
      <VisxXYChart theme={chartTheme} {...otherProps}>
        {children}
      </VisxXYChart>
    </Box>
  );
};
